export default __webpack_public_path__ + "static/media/zeev_banner.4bf44d9f.jpeg";